import { Link } from "react-router-dom"
import logo from "@/assets/talentickaiwhite.webp"
const Footer = ({ featScroll, pricingScroll, contactScroll }: {
    featScroll: () => void,
    pricingScroll: () => void
    , contactScroll: () => void
}) => {
    return (
        <footer className="bg-[#263238] text-white py-24">
            <div className="max-w-7xl mx-auto px-8  md:flex justify-between space-y-10 md:space-y-0">

                {/* Brand */}
                <div className="md:w-2/6 ">
                    <img
                        src={logo}
                        className=" max-h-10 cursor-pointer mb-6 "
                        alt="Logo"
                    />
                    <p className="text-sm text-gray-300">Copyright © 2025 talentick.ai.<br />All rights reserved</p>

                </div>
                <div className="md:flex justify-end gap-32  space-y-10 md:space-y-0 ">

                    {/* Company */}
                    <div>
                        <h3 className="text-lg font-semibold mb-4">Company</h3>
                        <ul className="space-y-2 text-sm text-gray-300">
                            <li><a className="cursor-pointer" onClick={featScroll} >Features</a></li>
                            <li><a className="cursor-pointer" onClick={pricingScroll} >Pricing</a></li>
                            <li><a className="cursor-pointer" onClick={contactScroll} >Contact us</a></li>

                        </ul>
                    </div>

                    {/* Support */}
                    <div>
                        <h3 className="text-lg font-semibold mb-4">Support</h3>
                        <ul className="space-y-2 text-sm text-gray-300">

                            <li><Link to="/terms-of-service" target="__blank">Terms of service</Link></li>
                            <li><Link to="/privacy-policy" target="__blank">Privacy policy</Link></li>
                        </ul>
                    </div>

                    {/* Newsletter */}
                    {/* <div>
                        <h3 className="text-lg font-semibold mb-4">Get the latest in AI hiring trends</h3>
                        <div className="flex items-center bg-gray-600 rounded-md py-2.5 px-4 ">
                            <input
                                type="email"
                                placeholder="Your email address"
                                className="w-full bg-transparent text-white placeholder-gray-300 outline-none"
                            />
                            <button className="ml-2 text-white">
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M17.0303 0.969691C17.2341 1.17342 17.3031 1.47584 17.2079 1.74778L11.9579 16.7478C11.8563 17.038 11.5878 17.2369 11.2806 17.2494C10.9733 17.2619 10.6895 17.0856 10.5646 16.8046L7.6818 10.3182L1.1954 7.43538C0.91439 7.31049 0.738092 7.02671 0.750627 6.71945C0.763163 6.41219 0.961991 6.14371 1.25224 6.04213L16.2522 0.792127C16.5242 0.696948 16.8266 0.765962 17.0303 0.969691ZM9.14456 9.91612L11.1671 14.4667L14.7064 4.35429L9.14456 9.91612ZM13.6457 3.29362L3.53331 6.83297L8.0839 8.85546L13.6457 3.29362Z" fill="white" />
                                </svg>

                            </button>
                        </div>
                    </div> */}
                </div>
            </div>
        </footer>
    )
}


export default Footer 